import { Section } from '../layout/Section';
import { SectionHeader } from '../layout/SectionHeader';
import { NotchedPanel } from '../ui/NotchedPanel';
import { Reveal } from '../ui/Reveal';
import { useInViewOnce } from '../../hooks/useInViewOnce';
import { associatePortal } from '../../data/landing';
import styles from './AssociatePortal.module.css';

/**
 * Destinations are placeholders — the product apps live on the dev branch and
 * have no public URLs yet. Logged in docs/CONTENT-GAPS.md.
 */
export function AssociatePortal() {
  const [gridRef, gridIn] = useInViewOnce();

  return (
    <Section id="portal">
      <SectionHeader
        eyebrow={associatePortal.eyebrow}
        title={associatePortal.title}
        subtitle={associatePortal.subtitle}
      />

      <Reveal>
        <NotchedPanel>
          <ul ref={gridRef} className={`${styles.grid} ${gridIn ? styles.gridIn : ''}`}>
            {associatePortal.links.map((link) => (
              <li key={link.label}>
                <a className={styles.link} href={link.href}>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </NotchedPanel>
      </Reveal>
    </Section>
  );
}
